/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	  (0, _module.anchorLink)();
	  (0, _module.togglePagetop)();
	  (0, _module.toggleMenu)();
	  (0, _module.toggleConfetti)();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toggleConfetti = exports.toggleMenu = exports.togglePagetop = exports.anchorLink = void 0;
	var breakPoint = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width(); // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var anchorLink = function anchorLink() {
	  $("a[href^=#]").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "swing");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// togglePagetop
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.anchorLink = anchorLink;
	
	var togglePagetop = function togglePagetop() {
	  $(window).on("scroll load", function () {
	    var scrollHeight = $(this).scrollTop();
	
	    if (scrollHeight > 400) {
	      $(".st-Pagetop").addClass("visible");
	    } else {
	      $(".st-Pagetop").removeClass("visible");
	    }
	  });
	}; // ------------------------------------------------------------------------
	// toggleMenu
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.togglePagetop = togglePagetop;
	
	var toggleMenu = function toggleMenu() {
	  $('.st-Header_Hamburger > .toggle').on('click', function () {
	    $(this).toggleClass("close");
	    $(".st-Header_Sp").toggleClass("menu_open");
	    $(".st-Header_Sp > .inner").toggleClass("menu_open");
	  });
	}; // ------------------------------------------------------------------------
	// toggleConfetti
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleMenu = toggleMenu;
	
	var toggleConfetti = function toggleConfetti() {
	  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
	
	  (function () {
	    // globals
	    var canvas;
	    var ctx;
	    var W;
	    var H;
	    var mp = 70; //max particles
	
	    var particles = [];
	    var angle = 0;
	    var tiltAngle = 0;
	    var confettiActive = true;
	    var animationComplete = true;
	    var deactivationTimerHandler;
	    var reactivationTimerHandler;
	    var animationHandler; // objects
	
	    var particleColors = {
	      colorOptions: ["#ffd96b", "#47bc63", "#47b4e1", "#ef589d"],
	      colorIndex: 0,
	      colorIncrementer: 0,
	      colorThreshold: 10,
	      getColor: function getColor() {
	        if (this.colorIncrementer >= 10) {
	          this.colorIncrementer = 0;
	          this.colorIndex++;
	
	          if (this.colorIndex >= this.colorOptions.length) {
	            this.colorIndex = 0;
	          }
	        }
	
	        this.colorIncrementer++;
	        return this.colorOptions[this.colorIndex];
	      }
	    };
	
	    function confettiParticle(color) {
	      this.x = Math.random() * W; // x-coordinate
	
	      this.y = Math.random() * H - H; //y-coordinate
	
	      this.r = RandomFromTo(10, 30); //radius;
	
	      this.d = Math.random() * mp + 10; //density;
	
	      this.color = color;
	      this.tilt = Math.floor(Math.random() * 10) - 10;
	      this.tiltAngleIncremental = Math.random() * 0.07 + .05;
	      this.tiltAngle = 0;
	
	      this.draw = function () {
	        ctx.beginPath();
	        ctx.lineWidth = this.r / 1.5;
	        ctx.strokeStyle = this.color;
	        ctx.moveTo(this.x + this.tilt + this.r / 4, this.y);
	        ctx.lineTo(this.x + this.tilt, this.y + this.tilt + this.r / 4);
	        return ctx.stroke();
	      };
	    }
	
	    $(document).ready(function () {
	      SetGlobals();
	      InitializeButton();
	      InitializeConfetti();
	      $(window).resize(function () {
	        if ($(window).width() > 1920) {
	          W = $('.idx-Main_Inner').innerWidth();
	          H = $('.idx-Main_Inner').innerHeight();
	        } else {
	          W = 1920;
	          H = 1080;
	        }
	
	        canvas.width = W;
	        canvas.height = H;
	      });
	    });
	
	    function InitializeButton() {
	      $('#stopButton').click(DeactivateConfetti);
	      $('#startButton').click(RestartConfetti);
	    }
	
	    function SetGlobals() {
	      canvas = document.getElementById("canvas");
	      ctx = canvas.getContext("2d");
	
	      if ($(window).width() > 1920) {
	        W = $('.idx-Main_Inner').innerWidth();
	        H = $('.idx-Main_Inner').innerHeight();
	      } else {
	        W = 1920;
	        H = 1080;
	      }
	
	      canvas.width = W;
	      canvas.height = H;
	    }
	
	    function InitializeConfetti() {
	      particles = [];
	      animationComplete = false;
	
	      for (var i = 0; i < mp; i++) {
	        var particleColor = particleColors.getColor();
	        particles.push(new confettiParticle(particleColor));
	      }
	
	      StartConfetti();
	    }
	
	    function Draw() {
	      ctx.clearRect(0, 0, W, H);
	      var results = [];
	
	      for (var i = 0; i < mp; i++) {
	        (function (j) {
	          results.push(particles[j].draw());
	        })(i);
	      }
	
	      Update();
	      return results;
	    }
	
	    function RandomFromTo(from, to) {
	      return Math.floor(Math.random() * (to - from + 1) + from);
	    }
	
	    function Update() {
	      var remainingFlakes = 0;
	      var particle;
	      angle += 0.01;
	      tiltAngle += 0.1;
	
	      for (var i = 0; i < mp; i++) {
	        particle = particles[i];
	        if (animationComplete) return;
	
	        if (!confettiActive && particle.y < -15) {
	          particle.y = H + 100;
	          continue;
	        }
	
	        stepParticle(particle, i);
	
	        if (particle.y <= H) {
	          remainingFlakes++;
	        }
	
	        CheckForReposition(particle, i);
	      }
	
	      if (remainingFlakes === 0) {
	        StopConfetti();
	      }
	    }
	
	    function CheckForReposition(particle, index) {
	      if ((particle.x > W + 20 || particle.x < -20 || particle.y > H) && confettiActive) {
	        if (index % 5 > 0 || index % 2 == 0) //66.67% of the flakes
	          {
	            repositionParticle(particle, Math.random() * W, -10, Math.floor(Math.random() * 10) - 20);
	          } else {
	          if (Math.sin(angle) > 0) {
	            //Enter from the left
	            repositionParticle(particle, -20, Math.random() * H, Math.floor(Math.random() * 10) - 20);
	          } else {
	            //Enter from the right
	            repositionParticle(particle, W + 20, Math.random() * H, Math.floor(Math.random() * 10) - 20);
	          }
	        }
	      }
	    }
	
	    function stepParticle(particle, particleIndex) {
	      particle.tiltAngle += particle.tiltAngleIncremental;
	      particle.y += (Math.cos(angle + particle.d) + 3 + particle.r / 2) / speed;
	      particle.x += Math.sin(angle);
	      particle.tilt = Math.sin(particle.tiltAngle - particleIndex / 3) * 15;
	    }
	
	    function repositionParticle(particle, xCoordinate, yCoordinate, tilt) {
	      particle.x = xCoordinate;
	      particle.y = yCoordinate;
	      particle.tilt = tilt;
	    }
	
	    function StartConfetti() {
	      if ($(window).width() > 1920) {
	        W = $('.idx-Main_Inner').innerWidth();
	        H = $('.idx-Main_Inner').innerHeight();
	      } else {
	        W = 1920;
	        H = 1080;
	      }
	
	      canvas.width = W;
	      canvas.height = H;
	
	      (function animloop() {
	        if (animationComplete) return null;
	        animationHandler = requestAnimFrame(animloop);
	        return Draw();
	      })();
	    }
	
	    function ClearTimers() {
	      clearTimeout(reactivationTimerHandler);
	      clearTimeout(animationHandler);
	    }
	
	    function DeactivateConfetti() {
	      confettiActive = false;
	      ClearTimers();
	    }
	
	    function StopConfetti() {
	      animationComplete = true;
	      if (ctx == undefined) return;
	      ctx.clearRect(0, 0, W, H);
	    }
	
	    function RestartConfetti() {
	      ClearTimers();
	      StopConfetti();
	      reactivationTimerHandler = setTimeout(function () {
	        confettiActive = true;
	        animationComplete = false;
	        InitializeConfetti();
	      }, 100);
	    }
	
	    window.requestAnimFrame = function () {
	      return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
	        return window.setTimeout(callback, 1000 / 60);
	      };
	    }();
	  })();
	};
	
	exports.toggleConfetti = toggleConfetti;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js